import {
  TaskManagementRemindTypeCreateDocument,
  TaskManagementRemindTypeDeleteDocument,
  TaskManagementRemindTypeGetByIdDocument,
  TaskManagementRemindTypeListByEntityTypeDocument,
  TaskManagementRemindTypeListDocument,
  TaskManagementRemindTypeListPaginatedDocument,
  TaskManagementRemindTypeUpdateDocument,
} from "api/generated";
import { RequestTypes } from "api/services/enums";
import { getRequestInstance } from "api/services/utils";
import { Optional } from "config";

import {
  ITaskManagementRemindTypeCreateUpdateResponse,
  ITaskManagementRemindTypeCreateVars,
  ITaskManagementRemindTypeGetByIdResponse,
  ITaskManagementRemindTypeListResponse,
  ITaskManagementRemindTypePaginatedResponse,
  ITaskManagementRemindTypePaginatedVars,
  ITaskManagementRemindTypeUpdateVars,
} from "./types";

export async function getTaskManagementRemindTypeListPaginated(
  variables: ITaskManagementRemindTypePaginatedVars
): Promise<Optional<ITaskManagementRemindTypePaginatedResponse>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: TaskManagementRemindTypeListPaginatedDocument,
      variables,
      fetchPolicy: "cache-first",
    });

    return res?.data?.taskManagementRemindTypeListPaginated;
  } catch (error) {
    throw error;
  }
}

export async function createTaskManagementRemindType(
  variables: ITaskManagementRemindTypeCreateVars
): Promise<Optional<ITaskManagementRemindTypeCreateUpdateResponse>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: TaskManagementRemindTypeCreateDocument,
      variables,
      fetchPolicy: "no-cache",
    });

    return res?.data?.taskManagementRemindTypeCreate;
  } catch (error) {
    throw error;
  }
}

export async function updateTaskManagementRemindType(
  variables: ITaskManagementRemindTypeUpdateVars
): Promise<Optional<ITaskManagementRemindTypeCreateUpdateResponse>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: TaskManagementRemindTypeUpdateDocument,
      variables,
      fetchPolicy: "no-cache",
    });

    return res?.data?.taskManagementRemindTypeUpdate;
  } catch (error) {
    throw error;
  }
}

export async function getTaskManagementRemindType(
  id: number
): Promise<Optional<ITaskManagementRemindTypeGetByIdResponse>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: TaskManagementRemindTypeGetByIdDocument,
      variables: {
        id,
      },
      fetchPolicy: "cache-first",
    });

    return res?.data?.taskManagementRemindTypeGetById;
  } catch (error) {
    throw error;
  }
}

export async function deleteTaskManagementRemindType(
  id: number
): Promise<boolean> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: TaskManagementRemindTypeDeleteDocument,
      variables: {
        id,
      },
      fetchPolicy: "no-cache",
    });

    return Boolean(res?.data?.taskManagementRemindTypeDelete);
  } catch (error) {
    throw error;
  }
}

export async function getTaskManagementRemindTypeList(): Promise<
  ITaskManagementRemindTypeListResponse[]
> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: TaskManagementRemindTypeListDocument,
      fetchPolicy: "cache-first",
    });

    return res?.data?.taskManagementRemindTypeList ?? [];
  } catch (error) {
    throw error;
  }
}

export async function getTaskManagementRemindTypeListByEntityType(
  entityTypeName?: string
): Promise<ITaskManagementRemindTypeListResponse[]> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: TaskManagementRemindTypeListByEntityTypeDocument,
      variables: {
        entityTypeName,
      },
      fetchPolicy: "cache-first",
    });

    return res?.data?.taskManagementRemindTypeListByEntityType ?? [];
  } catch (error) {
    throw error;
  }
}
